import { inject, injectable } from 'tsyringe';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { type IResponseMeetingRequestRepository } from 'application/repositorySchemas/IResponseMeetingRequestRepository';
import { type IAcceptedRequestMeetingClient } from 'interfaceAdapter/gatewaySchemas/IAcceptedRequestMeetingClient';
import { type IDeclinedMeetingRequestClient } from 'interfaceAdapter/gatewaySchemas/IDeclinedMeetingRequestClient';
import { type ICompanyBlockAgentClient } from 'interfaceAdapter/gatewaySchemas/ICompanyBlockAgentClient';

@injectable()
export class ResponseMeetingRequestRepository implements IResponseMeetingRequestRepository {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('IAcceptedRequestMeetingClient')
        public readonly acceptedRequestMeetingClient: IAcceptedRequestMeetingClient,
        @inject('IDeclinedMeetingRequestClient')
        public readonly declinedMeetingRequestClient: IDeclinedMeetingRequestClient,
        @inject('ICompanyBlockAgentClient')
        public readonly companyBlockAgentClient: ICompanyBlockAgentClient,
    ) {}

    public async accepted(match_id: number) {
        const { data, message } = await this.acceptedRequestMeetingClient.post({
            token: this.companyUserToken.get() || '',
            match_id,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async declined(match_id: number, reason: string) {
        const { data, message } = await this.declinedMeetingRequestClient.post({
            token: this.companyUserToken.get() || '',
            match_id,
            reason,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async blockAgent(match_id: number, message: string) {
        const { data, message: errorMessage } = await this.companyBlockAgentClient.post({
            token: this.companyUserToken.get() || '',
            match_id,
            message,
        });

        if (errorMessage) {
            throw new Error(errorMessage);
        }

        return data;
    }
}
